// Repris tel quel de Brackets.jsx — extrait ici pour être réutilisé par
// d'autres pages (ex: ParallelFisExport.jsx) sans dupliquer la logique.

export function getLoser(match, winner) {
    const { athleteA, athleteB } = match;
    if (!athleteA || !athleteB || !winner) return null;
    if (athleteA.fiscode === athleteB.fiscode) return null;
    if (winner.fiscode === athleteA.fiscode) return athleteB;
    if (winner.fiscode === athleteB.fiscode) return athleteA;
    return null;
}

// Déduit un classement final à partir du bracket : vainqueur de la finale =
// 1er, perdant de la finale = 2e, vainqueur de la petite finale = 3e,
// perdant de la petite finale = 4e, puis chaque perdant d'un même tour
// obtient un rang individuel séquentiel (pas d'ex-æquo), ordonné par rang
// de qualification ASCENDANT (le mieux classé aux qualifs parmi les
// éliminés de ce tour prend le meilleur rang du groupe).
export function deriveRanking(bracket) {
    const { rounds, smallFinal } = bracket;
    const ranking = [];
    const totalRounds = rounds.length;

    const final = rounds[totalRounds - 1]?.[0];
    if (final?.winner) {
        ranking.push({ ...final.winner, place: 1, stage: "Finale" });
        const loser = getLoser(final, final.winner);
        if (loser) ranking.push({ ...loser, place: 2, stage: "Finale" });
    }

    if (smallFinal?.winner) {
        ranking.push({ ...smallFinal.winner, place: 3, stage: "Petite finale" });
        const loser = getLoser(smallFinal, smallFinal.winner);
        if (loser) ranking.push({ ...loser, place: 4, stage: "Petite finale" });
    }

    for (let r = totalRounds - 3; r >= 0; r--) {
        const stage = rounds[r][0]?.label || `Tour ${r + 1}`;
        const losers = rounds[r]
            .map((m) => (m.winner ? getLoser(m, m.winner) : null))
            .filter(Boolean)
            .sort((a, b) => (a.qualifRank ?? 999999) - (b.qualifRank ?? 999999));

        losers.forEach((l) => {
            ranking.push({ ...l, place: ranking.length + 1, stage });
        });
    }

    return ranking;
}